import * as Dialog from "@radix-ui/react-dialog";
import { BookOpen, ExternalLink, X } from "lucide-react";
import { create } from "zustand";
import { IconButton } from "@/ui/IconButton";
import { DocsBrowser } from "./DocsBrowser";
import s from "./developers.module.css";

interface DocsDialogStore {
  open: boolean;
  setOpen: (open: boolean) => void;
}
export const useDocsDialog = create<DocsDialogStore>((set) => ({ open: false, setOpen: (open) => set({ open }) }));

/** Full-screen developer documentation inside the app. */
export function DocsDialog() {
  const { open, setOpen } = useDocsDialog();
  return (
    <Dialog.Root open={open} onOpenChange={setOpen}>
      <Dialog.Portal>
        <Dialog.Overlay className={s.dialogOverlay} />
        <Dialog.Content className={s.dialog} aria-describedby={undefined}>
          <div className={s.dialogHead}>
            <BookOpen size={16} />
            <Dialog.Title style={{ margin: 0, fontSize: "inherit" }}>Developer documentation</Dialog.Title>
            <span className={s.spacer} />
            <a className={s.pageLink} href="/developers" target="_blank" rel="noreferrer">
              Open in a tab <ExternalLink size={12} style={{ verticalAlign: "-2px" }} />
            </a>
            <Dialog.Close asChild>
              <IconButton label="Close">
                <X size={14} />
              </IconButton>
            </Dialog.Close>
          </div>
          <div className={s.dialogBody}>{open ? <DocsBrowser /> : null}</div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
